import React from 'react'

export const healthyBodies0To9Months = {
  title: 'Healthy Bodies',
  body: [
    [
      'Breast milk meets all your baby’s needs for about the first 6 months of life. Between 6 and 12 months of age, your baby will learn about new tastes and textures with healthy solid food, but breast milk should still be an important source of nutrition.',
      'Feed your baby slowly and patiently, encourage your baby to try new tastes but without force, and watch closely to see if he’s still hungry.',
      <>
      Breastfeeding is the natural way to feed your baby, but it can be challenging. If you need help, you can call the <a href='http://www.womenshealth.gov/breastfeeding'>National Breastfeeding Helpline</a> at <a href='tel:+18009949662'>1-800-994-9662</a> or click on the link for their website. You can also call your local WIC Program to see if you qualify for breastfeeding support by health professionals as well as peer counselors or use an <a href='https://portal.ilca.org/i4a/memberDirectory/index.cfm?directory_id=19&pageID=4356'>online directory to find an International Board-Certified Lactation Consultant</a> in your community.
      </>,
      'Keep your baby active. She might not be able to run and play like the “big kids” just yet, but there’s lots she can do to keep her little arms and legs moving throughout the day. Getting down on the floor to move helps your baby become strong, learn, and explore.',
      'Try not to keep your baby in swings, strollers, bouncer seats, and exercise saucers for too long.',
      'Limit screen time. For children younger than 18 months of age, the American Academy of Pediatrics (AAP) recommends that it’s best if babies do not use any screen media other than video chatting.',
      <>
      Make sure your child gets the <a href='https://www.cdc.gov/sleep/about_sleep/how_much_sleep.html'>recommended amount of sleep</a> each night: For infants 4-12 months, 12–16 hours per 24 hours (including naps)
      </>
    ]
  ]
}

export const healthyBodies12To18Months = {
  title: 'Healthy Bodies',
  body: [
    [
      "Give your child water and plain milk instead of sugary drinks. After the first year, when your nursing toddler is eating more and different solid foods, breast milk is still an ideal addition to his diet.",
      "Your toddler might become a very picky and erratic eater. Toddlers need less food because they don’t grow as fast. It’s best not to battle with him over this. Offer a selection of healthy foods and let him choose what she wants. Keep trying new foods; it might take time for him to learn to like them.",
      <>
      Limit screen time and develop a <a href='https://www.healthychildren.org/English/media/Pages/default.aspx'>media use plan for your family.</a> For children younger than 18 months of age, the American Academy of Pediatrics recommends that it’s best if toddlers not use any screen media other than video chatting.,
      </>,
      "Your toddler will seem to be moving continually—running, kicking, climbing, or jumping. Let him be active—he’s developing his coordination and becoming strong.",
      <>
      Make sure your child gets the <a href='https://www.cdc.gov/sleep/about_sleep/how_much_sleep.html'>recommended amount of sleep</a> each night: For toddlers 1-2 years, 11–14 hours per 24 hours (including naps)
      </>,
    ]
  ]
}

export const healthyBodies24To36Months = {
  title: 'Healthy Bodies',
  body: [
    [
      "Talk with staff at your child care provider to see if they serve healthier foods and drinks, and if they limit television and other screen time.",
      "Your toddler might change what food she likes from day to day. It’s normal behavior, and it’s best not to make an issue of it. Encourage her to try new foods by offering her small bites to taste.",
      <>
      Keep television sets out of your child’s bedroom. Set limits for screen time for your child to no more than 1 hour per day of quality programming, at home, school, or afterschool care and develop a <a href='https://www.healthychildren.org/English/media/Pages/default.aspx'>media use plan for your family</a>
      </>,
      "Encourage free play as much as possible. It helps your toddler stay active and strong and helps him develop motor skills.",
      <>
      Make sure your child gets the <a href='https://www.cdc.gov/sleep/about_sleep/how_much_sleep.html'>recommended amount of sleep</a> each night: For toddlers 1-2 years, 11–14 hours per 24 hours (including naps)
      </>
    ]
  ]
}
export const healthyBodies48MonthsOnward = {
  title: 'Healthy Bodies',
  body: [
    [
      "Eat meals with your child whenever possible. Let your child see you enjoying fruits, vegetables, and whole grains at meals and snacks. Your child should eat and drink only a limited amount of food and beverages that contain added sugars, solid fats, or salt.",
      <>
      Keep television sets out of your child’s bedroom. Set limits for screen time for your child to no more than 1 hour per day of quality programming, at home, school, or afterschool care and develop a <a href='https://www.healthychildren.org/English/media/Pages/default.aspx'>media use plan for your family</a>
      </>,
      "Provide your child with age-appropriate play equipment, like balls and plastic bats, but let your preschooler choose what to play. This makes moving and being active fun for your preschooler.",
      <>
      Make sure your child gets the <a href='https://www.cdc.gov/sleep/about_sleep/how_much_sleep.html'>recommended amount of sleep</a> each night: For preschoolers 3-5 years, 10–13 hours per 24 hours (including naps)
      </>,
    ],
  ]
}
